import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../container/Dashboard/Dashboard";
import PipesDetails from "../container/Pipes/PipesDetails";
import ProductDetails from "../container/ProductDetails/ProductDetail";
import UserProfile from "../container/userProfile/UserProfile";
import ChangePassword from "../container/Login/ChangePassword/ChangePassword";


const AuthenticationRoutes = () => {
    return (
        <>
            <Routes>
                <Route exact path="/" element={<Dashboard />} />
                <Route path="/pipes-details" element={<PipesDetails />} />
                <Route path="/product-details" element={<ProductDetails/>} />
                <Route path="/userprofile" element={<UserProfile/> } />
                <Route path="/change-password" element={<ChangePassword/>} />
            </Routes>
        </>
    )
}

export default AuthenticationRoutes;